import React from 'react';
import { translate } from 'react-switch-lang';
import { Link, withRouter } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import CookieConsent from 'react-cookie-consent';
import styled from 'styled-components';
import cockpit from './utils/cockpit';
import Routes from './Routes';
import Layout from './components/Layout';
import Header from './components/Header';

// STYLES
const Main = styled.main`
  position: relative;
`;

class App extends React.Component {

  state = {}

  componentDidMount() {
    cockpit.getSingleton('home').then(res => {
      this.setState({ home: res.data });
    });

    cockpit.getSingleton('hoerproben').then(res => {
      this.setState({ hoerproben: res.data });
    });

    cockpit.getSingleton('aktuelle_projekte').then(res => {
      this.setState({ aktuelleProjekte: res.data });
    });

    cockpit.getSingleton('ueber_mich').then(res => {
      this.setState({ ueberMich: res.data });
    });

    cockpit.getSingleton('stimmen_ueber_mich').then(res => {
      this.setState({ stimmenUeberMich: res.data });
    });

    cockpit.getSingleton('kontakt').then(res => {
      this.setState({ kontakt: res.data });
    });

    cockpit.getSingleton('imprint_privacy').then(res => {
      this.setState({ imprintPrivacy: res.data });
    });
  }

  render() {
    let result = null;
    const { home, hoerproben, aktuelleProjekte, ueberMich, stimmenUeberMich, kontakt, imprintPrivacy } = this.state

    if (home && hoerproben && aktuelleProjekte && ueberMich && stimmenUeberMich && kontakt && imprintPrivacy) {
      result = (
        <React.Fragment>
          <TransitionGroup>
            <CSSTransition
              key={ this.props.location.key }
              className="fade"
              timeout={{ enter: 300, exit: 300 }}
              mountOnEnter={ true }
              unmountOnExit={ true }
            >
              <Routes data={ this.state } />
            </CSSTransition>
          </TransitionGroup>
          {/* <CookieConsent buttonText="OK">
            Text <Link to="/privacy">Link</Link>
          </CookieConsent> */}
        </React.Fragment>
      );
    } else {
      result = null;
    }

    return (
      <Layout>
        <Header />
        <Main>
          { result }
        </Main>    
      </Layout>
    );
  }
}

export default translate(withRouter(App));
